import EscalationSupportView from './EscalationSupportView';

export default EscalationSupportView;
